import React from 'react'

import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className='notfound'>
        <h1> OOPS!!! The Page Is Not Found🐱‍🏍🤷‍♀️</h1>
        <button className='btn btn-primary' onClick={()=>{navigate('/')}}>HOME</button>
    </div>
  )
}

export default NotFound;